import { createSlice } from "@reduxjs/toolkit";
import {
  getRentalList,
  getRentalRequest,
  getRentalsForTrikeV3,
} from "../APIs/rentalsAPI";

const initialState = {
  loading: false,
  error: {},
  status: "idle",

  rentalsForTrike: {
    result: [],
    totalRecords: 0,
  },
  rentalsForTrikeLoading: false,

  rentalList: {
    result: [],
    totalRecords: 0,
  },

  requestRentalList: {
    result: [],
    totalRecords: 0,
  },

  showToastMessage: {
    visible: false,
    data: {},
  },

  moveToHubStationModal: false,

  currentRental: {},
  threeDotsPopoverId: 0,
  batteryEnergyModal: false,
  viewBatteryEnergyModal: false,
  checklistModal: {
    visible: false,
    data: {},
  },
};

export const rentalsSlice = createSlice({
  name: "rentals",
  initialState,
  reducers: {
    updateRental: (state, action) => {
      state[action.payload.key] = action.payload.value;
    },
  },
  extraReducers(builder) {
    // get rentals list
    builder.addCase(getRentalList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getRentalList.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";
      state.rentalList = action.payload.response;
    });
    builder.addCase(getRentalList.rejected, (state, action) => {
      state.loading = false;
      state.status = "rejected";
      state.error = action.error;
    });

    // get request rentals list
    builder.addCase(getRentalRequest.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getRentalRequest.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";
      state.requestRentalList = action.payload;
    });
    builder.addCase(getRentalRequest.rejected, (state, action) => {
      state.loading = false;
      state.status = "rejected";
      state.error = action.error;
    });

    // get rentals for trike
    builder.addCase(getRentalsForTrikeV3.pending, (state) => {
      state.rentalsForTrikeLoading = true;
    });
    builder.addCase(getRentalsForTrikeV3.fulfilled, (state, action) => {
      state.rentalsForTrikeLoading = false;
      state.rentalsForTrike = action.payload.response;
    });
    builder.addCase(getRentalsForTrikeV3.rejected, (state, action) => {
      state.rentalsForTrikeLoading = false;
      state.error = action.error;
    });
  },
});

export const { updateRental } = rentalsSlice.actions;

export default rentalsSlice.reducer;
